import { history } from "./history";

/**
 * @function menuClick
 * @return nothing
 * @desc This function handles redirections when user clicks on top right
 * user menu, navigateTo function is used for showing the selected menu item
 * in left nav
 */
export default (e, navigateTo, logout) => {
  switch (e.key) {
    case "1":
      history.push("/");
      navigateTo("dashboard", "dashboard");
      break;
    case "2":
      history.push("/doctors");
      navigateTo("doctors", "doctors");
      break;
    case "3":
      history.push("/labs");
      navigateTo("labs", "labs");
      break;
    case "4":
      history.push("/pharmacies");
      navigateTo("pharmacies", "pharmacies");
      break;
    case "5":
      history.push("/demo");
      navigateTo("demo", "demo");
      break;
    default:
      logout();
      break;
  }
};
